import {
    AlertsAcknowledgementRequest,
    AlertType,
    GroupAlertsAcknowledgementRequest,
} from '@kcftech/prometheus-client';
import { sdClient } from 'contexts/SDKClientContext';
import { assetStatusesQueryKey } from 'custom_hooks/data_hooks/asset/useAssetStatuses';
import { queryClient } from 'utils/query';
import { Lookup } from 'utils/types';

export const formattedAlertTypes: Lookup<AlertType, string> = {
    [AlertType.IndicatorHighWarning]: 'Warning',
    [AlertType.IndicatorLowWarning]: 'Warning',
    [AlertType.IndicatorHighAlarm]: 'Alarm',
    [AlertType.IndicatorLowAlarm]: 'Alarm',
    [AlertType.IndicatorCriticalHighAlarm]: 'Critical Alarm',
    [AlertType.IndicatorCriticalLowAlarm]: 'Critical Alarm',
};

export function acknowledgeAlertsByIds(request: AlertsAcknowledgementRequest) {
    const result = sdClient.acknowledgeAlertsByIds({ body: request });
    queryClient.invalidateQueries({
        queryKey: [assetStatusesQueryKey],
    });
    return result;
}

export function acknowledgeAlertsByGroupIds(request: GroupAlertsAcknowledgementRequest) {
    const result = sdClient.acknowledgeAlertsByGroupIds({ body: request });
    queryClient.invalidateQueries({
        queryKey: [assetStatusesQueryKey],
    });
    return result;
}
